export default __webpack_public_path__ + "static/media/interactive.e220e306.jpg";